import React from 'react';
import { Timeline } from 'components/timeline/Timeline';
import { TimelineItem } from 'components/timeline/TimelineItem';

export const Component = () => {
  const image = { url: 'https://picsum.photos/id/983/400/400', width: 400, height: 400 };

  return (
    <Timeline
      index={1}
      title="2019"
      tagline="Tagline"
      text={
        <p>
          This year Alvogen was founded on the strong foundation of Norwich Pharmaceutical services,
          with a 125-year history.
        </p>
      }
      isSlice
    >
      <TimelineItem
        category="Business"
        title="Alvogen brand is introduced"
        text="New business model is launched"
        image={image}
        caption="This is a caption"
      />

      <TimelineItem
        category="Business"
        title="Alvogen brand is introduced"
        text="New business model is launched"
        image={image}
      />

      <TimelineItem
        category="Business"
        title="Alvogen brand is introduced"
        text="New business model is launched"
        image={image}
      />

      <TimelineItem
        category="Business"
        title="Alvogen brand is introduced"
        text="New business model is launched"
        image={image}
      />

      <TimelineItem
        category="Business"
        title="Alvogen brand is introduced"
        text="New business model is launched"
        image={image}
      />
    </Timeline>
  );
};
